import { authRoles } from 'app/auth';
import VonalkodAdatlapTable from 'app/admin/vonalkodadatlap/table/VonalkodAdatlapTable';
import VonalkodAdatlapEditForm from 'app/admin/vonalkodadatlap/editform/VonalkodAdatlapEditForm';

export default [
	{
		path: '/vonalkodadatlap/edit/:id',
		component: VonalkodAdatlapEditForm,
		auth: authRoles.szervezo
	},
	{
		path: '/vonalkodadatlap/:sessionNameParam?',
		component: VonalkodAdatlapTable,
		auth: authRoles.szervezo
	}
];
